'use strict';
import { HttpClient } from '@angular/common/http';
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";

export const authStatus: boolean = false;

export const menuVertical: boolean = false;

import { Injectable } from '@angular/core';
@Injectable()
export class VariablesGlobales {
  /** Sous Menu **/
  public static annonceInfos: any;
  public editProfil: boolean = false;
  public editPassword: boolean = false;
  public editPasswordForced: boolean = false;
  public editStatus: boolean = false;

  /** Menu principal **/
  public editJobalert: boolean = false;
  public editPj: boolean = false;
  public editDossier: boolean = true;
  public editReponse: boolean = false;

  /** Theme service **/
  public color: string = 'accent';
  public colorHex: string = '';

  public header_color: string = '';
  public txt_home: string = '';
  public header_logo: string = '';

  constructor(private encdec: EncryptDecryptService, private http: HttpClient) {
    this.http.get('https://api2.sitederecrutement.com/Home/GetConfig?apikey=4Z387K3Xar78PaU53GrARtjkvUv23Hqj', { responseType: 'text' }).subscribe(
      result => {
        const jsonData = this.encdec.getDecrypt(result);
        const obj = JSON.parse(jsonData);

        this.color = obj.color;
        this.colorHex = obj.colorHex;
        this.header_color = obj.header_color;
        this.txt_home = obj.txt_home;
        this.header_logo = obj.header_logo;
      }
    );
  }
}
